<div class="row">
    <div class="col-md-12">
        <div class="card">
            <div class="card-header pb-0">
                <h1>Risk Contribution and Allocation <app-info infoIndex="9"></app-info> </h1>
            </div>
            <div class="card-body pt-0">
                <app-chart-placeholder [loaded]="loaded"></app-chart-placeholder>
                @if (loaded) {
                <highcharts-chart 
                                  [options]="chartOptions"
                                  style="width: 100%; height: auto; display: block;"
                ></highcharts-chart>
                }
            </div>
        </div>
    </div>
</div>

